import {
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  DELETE_PRODUCT_RESET,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const deleteProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_PRODUCT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        error: false,
        success: false,
        message: "",
      });

    case DELETE_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        success: true,
        error: false,
        message: (action.payload && action.payload.message) || "Product deleted successfully",
      });

    case DELETE_PRODUCT_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        success: false,
        message: (action.payload && action.payload.error) || "Failed to delete product",
      });

    case DELETE_PRODUCT_RESET:
      return Object.assign({}, initialState);

    default:
      return state;
  }
};

export default deleteProductReducer;
